import * as i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import type { PostProcessorModule } from 'i18next'
import enTranslations from '@/locales/en.json'
import deTranslations from '@/locales/de.json'

const i18n = i18next.default

const specialCharsPlugin: PostProcessorModule = {
  type: 'postProcessor',
  name: 'specialChars',
  process: (value: string, _key: string | string[], _options: object): string => value.replaceAll('{shy}', '\u00AD')
}

// Configure i18next to check local storage first, then browser language, then use German as fallback. Store
// preferences in local storage.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(specialCharsPlugin)
  .init({
    supportedLngs: ['en', 'de'],
    fallbackLng: 'de',
    resources: {
      en: {
        translation: enTranslations
      },
      de: {
        translation: deTranslations
      }
    },
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    postProcess: ['specialChars']
  })

export default i18n
